<template>
    <div class="app-container">
        <el-dialog
            :title="upgradeNotice.title"
            :visible.sync="tipsDialog"
            width="800px"
            class="upgrade-notice-dialog"
        >
            <div class="notice-content">
                <div class="notice-greeting" >
                    <p>{{ upgradeNotice.greeting1 }}</p>
                    <p style="text-indent: 2em;">{{ upgradeNotice.greeting2 }}</p>
                </div>
                <div class="notice-intro">
                    <p style="text-indent: 2em;">{{ upgradeNotice.intro }}</p>
                </div>
                <div class="notice-changes">
                    <p style="text-indent: 2em;">{{ upgradeNotice.changesTitle }}</p>
                    <ol class="changes-list" >
                        <li  v-for="(item, idx) in upgradeNotice.changes" :key="idx">
                            <template v-if="item && typeof item === 'object' && item.link">
                                {{ item.textBefore }}
                                <el-link type="primary" :underline="true" :href="item.link" target="_blank">{{ item.linkText }}</el-link>
                                {{ item.textAfter }}
                            </template>
                            <template v-else>
                                <span>{{ item }}</span>
                            </template>
                        </li>
                    </ol>
                </div>
                <div class="notice-migration">
                    <p style="text-indent: 2em;">{{ upgradeNotice.migration }}</p>
                </div>
                <div class="notice-signature">
                    <p>{{ upgradeNotice.signatureCompany }}</p>
                    <p>{{ upgradeNotice.signatureDate }}</p>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-checkbox v-model="dontRemindUpgradeNotice">下次不再提醒</el-checkbox>
                <el-button type="primary" @click="ackUpgradeNotice">我已知晓</el-button>
            </div>
        </el-dialog>

        <el-row :gutter="30" v-if='paperList.length>0'>
            <el-col :sm='{span:12}' :lg='{span:6}' :md='{span:8}' v-for="(item,index) in paperList" :key="item.paperId"
                style="margin-top:5px;margin-bottom:2vh">
                <paper-cover :title="item.title" :endTime="item.endTime" :institution="item.institution"
                    :reward="item.reward" :paperId="item.paperId" :reviewId="item.reviewId" :isRe='item.isRe' :allowSave='item.allowSave'
                    :paperUrl='item.paperUrl' :paperType="item.type" :annexUrl="item.annexUrl">
                </paper-cover>
            </el-col>
        </el-row>
        <div class="notPaper" v-else>
            <!-- 暂无待评审论文 -->
            <el-empty description="暂无待评审论文"></el-empty>
        </div>
        <change-info :expertId='expertId'></change-info>
    </div>
</template>

<script>
    import paperCover from '@/components/unfinished/paperCover'
    import changeInfo from '@/components/personalInfo/changeInfo'
    export default {
        name: "unfinishedList",
        data() {
            return {
                paperList: [
                ],
                expertId: '',
                changeDiaVis: false,

                tipsDialog: false,
                dontRemindUpgradeNotice: false,
                upgradeNotice: {
                    // 文案来自 1.text
                    title: '关于平台升级的重要通知',
                    greeting1: '尊敬的专家：',
                    greeting2: '您好！',
                    intro: '感谢您一直以来对江苏高擎的信任与支持。为了给各位专家提供更加高效、便捷的评审体验，我平台已启用全新的专家端评审系统（人事材料评审除外）。',
                    changesTitle: '您将会面临以下几项变化：',
                    changes: [
                        {
                            textBefore: '通过全新的评审网址',
                            link: 'https://expert.guidgine.com',
                            linkText: 'https://expert.guidgine.com',
                            textAfter: '登录评审；'
                        },
                        '通过全新的邮箱域名（sevice@guidgine.com）收到评审邀请；',
                        '获得全新的平台账号及登录方式；',
                        '可以通过微信小程序便捷地接收通知及提取评审费用。'
                    ],
                    migration: '新平台上线后，您仍可登录当前平台查阅历史评审记录，我们将在一段时间后，将当前平台的数据逐步迁移到新平台。',
                    signatureCompany: '江苏高擎教育评估有限公司',
                    signatureDate: '2026年1月21日'
                }
            }
        },
        created() {
            // this.expertId = sessionStorage.getItem("expertId");
            //获取待评审列表
            // this.$store.dispatch("changeExpertId", this.expertId);
            this.getPaperList();
            this.checkInfo();
            this.maybeShowUpgradeNotice();
        },
        methods: {
            maybeShowUpgradeNotice() {
                const key = 'upgrade_notice_no_remind';
                try {
                    const noRemind = localStorage.getItem(key) === '1';
                    if (!noRemind) this.tipsDialog = true;
                } catch (e) {
                    // localStorage 不可用时，仍然展示一次
                    this.tipsDialog = true;
                }
            },
            ackUpgradeNotice() {
                const key = 'upgrade_notice_no_remind';
                if (this.dontRemindUpgradeNotice) {
                    try {
                        localStorage.setItem(key, '1');
                    } catch (e) {
                        // ignore
                    }
                }
                this.tipsDialog = false;
            },
            getPaperList() {
                this.$api.unfinished.getReviewingPaperList()
                    .then(res => {
                        if (res.data.code == 200) {
                          console.log(res.data.data)
                            this.paperList = res.data.data;
                        }
                    }).catch(err => {
                        this.$message.warning("服务器维护！");
                    })
            },
            checkInfo() {
                if (this.$store.state.professor.isLogin == 1) return;
                this.$store.dispatch('professor/changeIsLogin', 1);
                this.$api.info.getCheckInfo().then(res => {
                        if (res.data.code == 1) {
                            this.$store.dispatch('professor/changeIsChangeDiaVis', true);
                        } else {
                            this.$store.dispatch('professor/changeIsChangeDiaVis', false);
                        }
                    })
                    .catch(err => {
                        this.$message.warning("服务器维护！");
                    })
            },
        },
        components: {
            "paper-cover": paperCover,
            'change-info': changeInfo,
        }
    }
</script>

<style scoped>
    /* 平台升级通知对话框样式（从登录页迁移） */
    .upgrade-notice-dialog ::v-deep .el-dialog__header {
        text-align: center;
        padding: 20px 20px 10px;
        border-bottom: none;
    }

    .upgrade-notice-dialog ::v-deep .el-dialog__title {
        font-size: 18px;
        font-weight: bold;
        color: #333;
    }

    .upgrade-notice-dialog ::v-deep .el-dialog__body {
        padding: 20px 30px 30px;
    }

    .notice-content {
        color: #333;
        line-height: 1.8;
        font-size: 14px;
    }

    .notice-greeting {
        margin-bottom: 15px;
    }

    .notice-greeting p {
        margin: 5px 0;
    }

    .notice-intro {
        margin-bottom: 20px;
        text-indent: 0;
    }

    .notice-intro p {
        margin: 0;
        text-align: justify;
    }

    .notice-changes {
        margin-bottom: 20px;
    }

    .notice-changes > p {
        margin-bottom: 10px;
        font-weight: 500;
    }

    .changes-list {
        margin: 10px 0;
        padding-left: 25px;
    }

    .changes-list li {
        margin-bottom: 8px;
        text-align: justify;
    }

    .notice-migration {
        margin-bottom: 25px;
    }

    .notice-migration p {
        margin: 0;
        text-align: justify;
    }

    .notice-signature {
        text-align: right;
        margin-top: 30px;
        padding-right: 20px;
    }

    .notice-signature p {
        margin: 5px 0;
        color: #666;
    }

    .dialog-footer {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 12px;
        padding-right: 10px;
    }

    .unfinishedMain {
        margin-right: 1rem;
    }

    .notPaper {
        text-align: center;
        font-size: 24px;
        color: rgb(77, 86, 95);
    }
</style>